import axios from 'axios'

export const rootService = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL
})
